import React, { Component } from "react";
import { CONTEXT_ROOT } from "../../utils";
import Styles from "./styles.css";

export class APIAlertPopup extends Component {
  state = {};

  constructor(props) {
    super(props);
  }

  handleProceed = () => {
     window.location.replace(window.location.href);
  };
  render() {
    const {  } = this.props;
    const assetsPath = `${CONTEXT_ROOT}/assets/images/`;

    return (
      <div className="modal">
        <div className="scroll">
          <div className="alert-container">
            <div className="section">
              <div className="info-container">
                <div className="description heading">
                  Non sono presenti pratiche associate ai dati inseriti 
                  
                </div>
                <div className="description textsize">
                Assicurati che i dati inseriti corrispondino a quelli utilizzati in fase di richiesta.
                </div>
                <div className="btnPosition">
                <button onClick={this.handleProceed}>
                 Riprova
                </button>
                </div>
              </div>
            </div>
            <div className="section">
              <div className="info-container">
                <div className="description textsize">
                  In alternativa ricomincia la tua richiesta : <a href="https://axerve.com/punto-vendita">Inizia la richiesta</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default APIAlertPopup;



// WEBPACK FOOTER //
// ./components/apiAlertPopup/index.js